import { useState } from 'react';
import { HandThumbsDown, HandThumbsUp } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';

import { Button, Space, message } from 'antd';

import { setNotification } from '@/redux/notification/slice';
import { useAcceptInviteMutation, useRefuseInviteMutation } from '@/services/invites';
import { StyledProp } from '@/styled';

import ConfirmRefuse from '../ConfirmRefuse';

const Actions = (props: { hash: string } & StyledProp) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>();
  const [refuseInvite, refusedInvite] = useRefuseInviteMutation();
  const [acceptInvite] = useAcceptInviteMutation();
  const dispatch = useDispatch();

  const handleAcceptInvite = () => {
    acceptInvite(props.hash)
      .then(() => {
        message.success('Convite aceito com sucesso!');
        dispatch(setNotification(null));
      })
      .catch(() => {
        message.error('Erro ao aceitar convite');
      });
  };

  const handleOpenRefuseModal = () => {
    setIsModalOpen(true);
  };

  const handleRefuseInvite = () => {
    refuseInvite(props.hash)
      .then(() => {
        message.success('Convite recusado com sucesso!');
        dispatch(setNotification(null));
      })
      .catch(() => {
        message.error('Erro ao recusar o convite');
      })
      .finally(() => {
        setIsModalOpen(isModalOpen => !isModalOpen);
      });
  };

  return (
    <div className={props.className}>
      <ConfirmRefuse
        open={isModalOpen}
        handleRefuseInvite={handleRefuseInvite}
        setOpen={() => setIsModalOpen(false)}
        isLoading={refusedInvite.isLoading}
      />
      <Space size={16} rootClassName='actions'>
        <Button type='default' icon={<HandThumbsDown size={12} />} onClick={handleOpenRefuseModal}>
          Recusar
        </Button>
        <Button type='default' icon={<HandThumbsUp size={12} />} className='accept' onClick={handleAcceptInvite}>
          Aceitar
        </Button>
      </Space>
    </div>
  );
};

export default Actions;
